// The tally behind a specific skill's score (media-ux §5): five level slots,
// one dot per contributing assessment, the LEAF'S OWN statistic marked. That
// statistic is the ROUNDED AVERAGE of the student's own assessments — the one
// hop that is deliberately a mean ("one average, then medians all the way up",
// the grading & disc doc; cross-project pooling ruled intended 2026-07-13,
// equal opportunity assumed wherever a project assesses the specific skill).
// The median appears only as labelled reference text in the tooltip.
import { ordinalMedian } from '../../lib/discStats';
import { cn } from '../../lib/cn';

export default function ScoreTally({ scores }) {
  const valid = (scores || []).map(Number).filter((n) => n >= 1 && n <= 5);
  if (valid.length === 0) return null;
  const mean = valid.reduce((a, b) => a + b, 0) / valid.length;
  const marked = Math.min(5, Math.max(1, Math.round(mean)));
  const median = ordinalMedian(valid);

  return (
    <div>
      <div
        className="grid grid-cols-5 gap-1.5"
        title={`exact average ${mean.toFixed(2)} · median ${median} (reference)`}
      >
        {[1, 2, 3, 4, 5].map((level) => {
          const n = valid.filter((s) => s === level).length;
          const isMarked = level === marked;
          return (
            <div
              key={level}
              className={cn(
                'relative flex min-h-[52px] flex-col items-center justify-end rounded-lg border bg-card px-1 pb-1 pt-2',
                isMarked ? 'border-primary shadow-[0_0_0_2px_rgba(91,83,230,0.15)]' : 'border-border'
              )}
            >
              {isMarked && (
                <span className="absolute -top-2 rounded-full bg-primary px-1.5 text-[8.5px] font-extrabold uppercase tracking-wide text-primary-foreground">
                  average
                </span>
              )}
              <span className="flex min-h-[18px] flex-wrap items-end justify-center gap-[3px]">
                {Array.from({ length: n }).map((_, i) => (
                  <span key={i} className="size-[7px] rounded-full bg-foreground/60" />
                ))}
              </span>
              <span className="mt-1 text-[10px] font-bold text-muted-foreground">{level}</span>
            </div>
          );
        })}
      </div>
      <p className="mt-1.5 text-[11px] text-muted-foreground">
        average of {valid.length} assessment{valid.length === 1 ? '' : 's'} · rounds to the nearest
        level
      </p>
    </div>
  );
}